export class Pagination {
  page?: number;
  perPage?: number;
  lastPage?: number;
  totalItemCount?: number;
}
